<section class="nw_service_th" *ngIf="!loader && businessListData.length > 0">
  <div class="service_se">
    <div class="heading_sert">
      <h3>All members</h3>
    </div>
    <div class="chip_services_list">
      <mat-chip-list>
        <mat-chip
          (click)="selectBusiness(i)"
          *ngFor="let item of businessListData; let i = index"
          [ngClass]="{ 'Graceful-box-active': item.isSelected == 1 }"
          >{{ item.name }}</mat-chip
        >
      </mat-chip-list>
    </div>
  </div>

  <div class="service_create_sd">
    <div class="row">
      <div class="col-sm-9">
        <div class="serv_heading">
          <h3>All members of {{ selectedBusiness.name }}</h3>
          <p>{{ selectedBusiness.address_line }}</p>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="select_thth">
          <div class="create_btn_sd">
            <button mat-flat-button color="primary" (click)="addmember()">
              <mat-icon>add</mat-icon>
              Add member
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="chip_cont">
    <mat-chip-list aria-label="Fish selection" class="mb-3">
      <mat-chip
        style="height: auto"
        [ngClass]="{ selected: selectedValue == '1' }"
        (click)="changeChip('1')"
        >All members
      </mat-chip>
      <mat-chip
        style="height: auto"
        [ngClass]="{ selected: selectedValue == '2' }"
        (click)="changeChip('2')"
        > Members with dues
      </mat-chip>
      <mat-chip
        style="height: auto"
        [ngClass]="{ selected: selectedValue == '0' }"
        (click)="changeChip('0')"
        >Ex members
      </mat-chip>
    </mat-chip-list>
 
  </div> -->
  <div style="margin-bottom: 10px" *ngIf="!loader">
    <div class="search-field" style="margin-bottom: 10px">
      <mat-form-field appearance="outline" class="me-2 w-100">
        <mat-label>{{ "customers.search_label" | translate }}</mat-label>
        <input
          [formControl]="searchString"
          matInput
          placeholder="{{ 'customers.search_placeholder' | translate }}"
          (keyup)="searchServiceData()"
        />
        <button
          mat-button
          *ngIf="!searchString.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
        >
          <mat-icon>search</mat-icon>
        </button>
        <button
          mat-button
          *ngIf="searchString.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="reset()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
    <!-- <sm-title-bar pageSubTitle="Services" [showBackButton]="true"></sm-title-bar> -->
    <div class="rounded-3 bg-light" *ngIf="!loader && membersData.length > 0">
      <sm-data-table
        [columnHeaders]="tableDisplayColumns"
        [dataSource]="membersData"
        [showMenuButton]="true"
        [menuDropdownTemplate]="menuTemplate"
        [showPagination]="true"
        [showImageColumn]="true"
        [imageTemplate]="image"
        [itemsPerPage]="25"
      >
      </sm-data-table>
    </div>
  </div>

  <ng-template #menuTemplate let-rowvalue>
    <button mat-menu-item (click)="goviewdetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View details</span>
    </button>
    <button
      mat-menu-item
      (click)="createInvoiceForEnrolled(rowvalue)"
      *ngIf="
        (selectedValue == '1' || selectedValue == '2') &&
        getInvoiceAccess(rowvalue.service_mode)
      "
    >
      <mat-icon class="material-icons-outlined">playlist_add</mat-icon>
      <span>Create membership invoice</span>
    </button>
    <!-- <button mat-menu-item (click)="openAllInvoices(rowvalue)">
      <mat-icon class="material-icons-outlined">receipt</mat-icon>
      <span>See all payments</span>
    </button> -->
    <button mat-menu-item (click)="openDueInvoices(rowvalue)">
      <mat-icon class="material-icons-outlined">pending_actions</mat-icon>
      <span>See due payments</span>
    </button>
    <button
      mat-menu-item
      (click)="openPaymentIntimation(rowvalue)"
      *ngIf="rowvalue.total_due > 0 && selectedBusiness.is_owner == 1"
    >
      <mat-icon class="material-icons-outlined">share</mat-icon>
      <span>{{ "customers.op3" | translate }}</span>
    </button>
    <!-- <button mat-menu-item (click)="openViewAttendance(rowvalue)" *ngIf="isEntityIndividual == '1'">
      <mat-icon class="material-icons-outlined">fact_check</mat-icon>
      <span>View attendance</span>
    </button> -->
    <button
      mat-menu-item
      (click)="openmarkabsent(rowvalue)"
      *ngIf="isEntityIndividual == '1' && selectedValue != '0'"
    >
      <mat-icon class="material-icons-outlined">disabled_by_default</mat-icon>
      <span>Mark absent</span>
    </button>
    <!-- <button mat-menu-item (click)="customerviewdetails()">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View details</span>
    </button> -->
  </ng-template>

  <ng-template #image let-objValue>
    <div style="position: relative">
      <img
        onerror="this.src = '../../../../assets/images/user-avatar.svg'"
        [src]="
          objValue['image_thumb_url'] !== null &&
          objValue['image_thumb_url'] !== 'null' &&
          objValue['image_thumb_url'] !== ''
            ? objValue['image_thumb_url']
            : '../../../../assets/images/user-avatar.svg'
        "
        class="img-fluid rounded-circle"
      />
      <div class="error_ioer" *ngIf="objValue['dispute_status'] == 2">
        <mat-icon>error</mat-icon>
      </div>
    </div>
  </ng-template>

  <!-- placeholder html start -->
  <div class="placeholder_started" *ngIf="!loader && membersData.length == 0">
    <div class="row">
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/members-dues.jpg" />
              </div>
              <mat-card-title>No members to show.</mat-card-title>
              <mat-card-content
                >It seems like you haven't started on-boarding members to your
                business. Start adding here and manage professionally.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="addmember()"
                >
                  <mat-icon>add</mat-icon>
                  Add member
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div class="col-sm-4 col-md-4 col-12">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/all-members.svg" />
              </div>
              <mat-card-title>How to manage members?</mat-card-title>
              <mat-card-content>
                Check our
                <span
                  class="ghtunderline"
                  (click)="openLink('https://lookzup.com/help')"
                >
                  help document
                </span>
                to manage membership in your business. You can check this video
                as well to get step by step help.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="openvideo()"
                >
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/helpsupport.png" />
              </div>
              <mat-card-title>Facing any issue?</mat-card-title>
              <mat-card-content
                >For any difficulties in creating a new customer or if there's
                any issue with customer data, contact the support team.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="opencontact()"
                >
                  <mat-icon>support_agent</mat-icon>
                  Contact support
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
  <!-- placeholder html end -->
</section>
<section class="nw_service_th" *ngIf="!loader && businessListData.length == 0">
  <div class="">
    <div class="heading_sert">
      <h3>All members</h3>
    </div>
  </div>

  <!-- Placeholder design html start -->
  <div class="placeholder_started__business">
    <div class="row">
      <div
        class="col-sm-4"
        *ngIf="!isEmployeeAndHasBusinessButDoesNotHaveAccess"
      >
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img
                  src="./assets/images/business-create.png"
                  style="width: 110px"
                />
              </div>
              <mat-card-title>No business added yet.</mat-card-title>
              <mat-card-content
                >To add your members you need to create a business first.
                Members will be added under that business.
              </mat-card-content>
              <div class="create_btnyh">
                <button
                  mat-flat-button
                  color="primary"
                  (click)="selectcountry()"
                >
                  <mat-icon>add</mat-icon>
                  Create a business
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div
        class="col-sm-4"
        *ngIf="isEmployeeAndHasBusinessButDoesNotHaveAccess"
      >
        <div class="dashboard_new">
          <mat-card appearance="outlined" style="">
            <div class="upload_sectio">
              <div class="icm_img">
                <img
                  src="./assets/images/business-create.png"
                  style="width: 110px"
                />
              </div>
              <mat-card-title>Access denied.</mat-card-title>
              <mat-card-content>
                Business owner with valid premium business subscription or an
                active employee with permission can access this section. Check
                current plans. Recharge pack if expired.
              </mat-card-content>
            </div>
          </mat-card>
        </div>
      </div>
      <!-- new card -->
      <div class="col-sm-4 col-md-4 col-12">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/all-members.svg" />
              </div>
              <mat-card-title>How to manage members?</mat-card-title>
              <mat-card-content>
                Check our
                <span
                  class="ghtunderline"
                  (click)="openLink('https://lookzup.com/help')"
                >
                  help document
                </span>
                to manage membership in your business. You can check this video
                as well to get step by step help.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="openvideo()"
                >
                  <mat-icon>play_arrow</mat-icon>
                  Watch video
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>

      <!-- new card end -->
      <div class="col-sm-4">
        <div class="dashboard_new">
          <mat-card>
            <div class="upload_sectio">
              <div class="icm_img">
                <img src="./assets/images/helpsupport.png" />
              </div>
              <mat-card-title>Having any issue?</mat-card-title>
              <mat-card-content
                >For any difficulties in adding members or if there's any issue
                while adding members, contact our support team.
              </mat-card-content>
              <div class="watch_vc_btn">
                <button
                  mat-stroked-button
                  color="primary"
                  (click)="opencontact()"
                >
                  <mat-icon>support_agent</mat-icon>
                  Contact support
                </button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </div>
  </div>
  <!-- Placeholder design html start -->
</section>
